module.exports = __webpack_public_path__ + "img/close-button.044a5ff7.svg";